import { useState } from 'react'
import { Grid2, IconButton, Stack, Typography } from '@mui/material';
import { Field } from 'formik';
import { useTicketDropdownOptions } from '../admin/ticket/TicketOption';
import { useGetAssignedTicket, useGetTicketsByRole } from '../../assets/nodeApi/getApi/getCommonApi';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField';
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDialog } from '../../shared/hook/useDialog';
import { getFileUrl } from '../../shared/utils/getFileUrl';
import { Grid_Gap } from '../../shared/constants';
const AssignedTicketList = () => {
    const [selectedTicket, setSelectedTicket] = useState({})
    const [filters, setFilters] = useState({});
    const { data: ticketList, isLoading } = useGetTicketsByRole(filters)
    const { priorityLevel, ticketStatus, ticketCategory } = useTicketDropdownOptions()
    const { open, handleClickOpen, handleClose } = useDialog();
    const ticketOption =
        ticketList?.tickets?.map((item, index) => ({
            id: item.id,
            label: item?.ticketId,
            value: item?.ticketId,
            sr_no: index + 1,
            ...item
        })) ?? [];
    const ticketColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "ticketId",
            headerName: "Ticket Id",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "category",
            headerName: "Category",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "priority",
            headerName: "Priority",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>
        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.8,

            renderCell: (params) => <Typography variant="body2">{params?.value}</Typography>
        },
        {
            field: "createdby",
            headerName: "Created By",
            flex: 0.8,
            renderCell: (params) => <Typography variant="body2">{params?.row?.createdBy?.firstname}{""}{params?.row?.createdBy?.lastname}</Typography>
        },
        {
            field: "attachments",
            headerName: "Attachments",
            flex: 1,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        onClick={() => { setSelectedTicket(params.row); handleClickOpen() }}
                        size="small"
                    >
                        <VisibilityIcon color="text.primary" />
                    </IconButton>
                </Stack>
            ),
        },


    ];

    return (
        <>
            <TableFilterTemplate
                title="Ticket List"
                columns={ticketColumns}
                rowsData={ticketOption || []}
                isLoading={isLoading}
            // filterInitialValues={filters}
            // filterReset={() => setFilters({})}
            // onApplyFilters={(f) => setFilters(f)}
            // renderFilterFields={() => (
            //     <>
            //         <Grid2 children size={12}>
            //             <Field
            //                 name="priority"
            //                 component={AutoCompleteField}
            //                 options={priorityLevel.options}
            //                 label="Priority Level"

            //             />
            //         </Grid2>
            //         <Grid2 children size={12}>
            //             <Field
            //                 name="category"
            //                 component={AutoCompleteField}
            //                 options={ticketCategory.options}
            //                 label="Ticket Category"

            //             />
            //         </Grid2>
            //         <Grid2 children size={12}>
            //             <Field
            //                 name="status"
            //                 component={AutoCompleteField}
            //                 options={ticketStatus.options}
            //                 label="Ticket Status"

            //             />
            //         </Grid2>
            //     </>
            // )}
            />

            <MainDialogBox open={open} handleClose={handleClose} width={"50%"} heading={"Attachments List"}>
                <Grid2 container spacing={Grid_Gap}>
                    {selectedTicket?.attachments?.length > 0 ? (
                        selectedTicket.attachments.map((item, index) => (
                            <Grid2 key={index} size={6}>
                                <img src={getFileUrl(item?.url)} width="100%" alt={`Attachment ${index + 1}`} />
                            </Grid2>
                        ))
                    ) : (
                        <Grid2 size={12}>
                            <Typography variant="body2" >
                                No attachments
                            </Typography>
                        </Grid2>
                    )}

                </Grid2>
            </MainDialogBox>


        </>
    )
}

export default AssignedTicketList;

